var MainMenuLeftSideBar = null;

(function () {
    $(function () {
        var SideBAR;
        SideBAR = (function () {
            function SideBAR() { }

            SideBAR.prototype.expandMyMenu = function () {
                // show overlay
                if ($(".overlaysbm").length > 0 && !($(".overlaysbm").hasClass("active")))
                    $('.overlaysbm').addClass('active');
                if ($("#divSidebar").length > 0 && !($("#divSidebar").hasClass("sidebar")))
                    $("#divSidebar").addClass("sidebar");
                var res = $("#divSidebar").removeClass("panel-collapsed").addClass("panel-expanded");
                return res;
            };

            SideBAR.prototype.collapseMyMenu = function () {
                if ($("#divSidebar").length > 0 && ($("#divSidebar").hasClass("sidebar")))
                    $("#divSidebar").removeClass("sidebar");
                // hide overlay
                if ($(".overlaysbm").length > 0 && ($(".overlaysbm").hasClass("active")))
                    $('.overlaysbm').removeClass('active');
                return $("#divSidebar").removeClass("panel-expanded").addClass("panel-collapsed");
            };

            SideBAR.prototype.showMenuTexts = function () {
                $("#divSidebar div a span.caret").show();
                return $("#divSidebar div a span.expanded-element").show();
            };

            SideBAR.prototype.hideMenuTexts = function () {
                $("#divSidebar div a span.caret").hide();
                return $("#divSidebar div a span.expanded-element").hide();
            };

            SideBAR.prototype.showActiveSubMenu = function () {
                $("div.active div.level2").show();
                return $("div.active a.expandable").css({
                    width: "100%"
                });
            };           

            SideBAR.prototype.hideActiveSubMenu = function () {
                return $("div.active div.level2").hide();
            };

            SideBAR.prototype.adjustPaddingOnExpand = function () {
                $("div.level1 div a.expandable").css({
                    padding: "1px 4px 4px 0px"
                });
                return $("div.level1 div.active a.expandable").css({
                    padding: "1px 4px 4px 4px"
                });
            };

            SideBAR.prototype.resetOriginalPaddingOnCollapse = function () {
                $("div.level1 div a.expandable").css({
                    padding: "4px 4px 4px 0px"
                });
                return $("div.level1 div.active a.expandable").css({
                    padding: "4px"
                });
            };

            SideBAR.prototype.ExpandSideBar = function () {
                return (function (instance) {
                instance.expandMyMenu();
                instance.showMenuTexts();
                instance.showActiveSubMenu();
                })(this);
            };

            SideBAR.prototype.CollapseSideBar = function () {
                return (function (instance) {
                instance.collapseMyMenu();
                })(this);
            };

            SideBAR.prototype.init = function () {
                return (function (instance) {
                    $(this).css({
                        color: "#000"
                    });
                    MainMenuLeftSideBar = instance;
                    return instance;
                })(this);
            };

            SideBAR.prototype.ignite = function () {
                return (function (instance) {
                    return $("#justify-icon").on("click",function (e) {
                        if ($("#divSidebar").hasClass("panel-collapsed")) {
                            instance.ExpandSideBar();
                        } 
                        else if ($("#divSidebar").hasClass("panel-expanded")) {
                            instance.CollapseSideBar();
                        }
                        return false;
                    });
                })(this);
            };
            return SideBAR;
        })();
        return (new SideBAR).init().ignite();
    });
}).call(this);

$(document).ready(function () {
    $(".actionMnItem, .overlaysbm, .footerLinks").click(function (event) {
        //close the sidebar
        if ($('#divSidebar').length > 0) {
            if (MainMenuLeftSideBar && MainMenuLeftSideBar.CollapseSideBar != undefined)
                MainMenuLeftSideBar.CollapseSideBar();
        }
    });
});
